import framePage from '../framePage';

function hideLoading($button, extraClasses) {
	framePage.allowSubmit = true;
	$button
		.addClass(extraClasses)
		.removeClass('loading')
		.removeAttr('aria-busy');
}

export default hideLoading;



// WEBPACK FOOTER //
// ./app/public/src/js/signin/frame/utils/loading/hideLoading.js